import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconArrowLeft, LazyIconArrowRight, LazyIconCloseCircle, LazyIconCopyLink, LazyIconCreate, LazyIconDefaultAvatar, LazyIconDelete, LazyIconDeleteCircle, LazyIconDiscover, LazyIconEmail, LazyIconEmpty, LazyIconEnhance, LazyIconEntrance, LazyIconError, LazyIconFacebook, LazyIconFavoriteCollect, LazyIconFavorite, LazyIconFire, LazyIconMore, LazyIconNameEditFinish, LazyIconNameEdit, LazyIconPic, LazyIconProfile, LazyIconReddit, LazyIconReviewReject, LazyIconSearch, LazyIconShare, LazyIconShread, LazyIconTabRight, LazyIconTrash, LazyIconTrends, LazyIconTwitter, LazyIconTxtToImg, LazyIconXxxx } from '#components'
const lazyGlobalComponents = [
  ["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRight", LazyIconArrowRight],
["IconCloseCircle", LazyIconCloseCircle],
["IconCopyLink", LazyIconCopyLink],
["IconCreate", LazyIconCreate],
["IconDefaultAvatar", LazyIconDefaultAvatar],
["IconDelete", LazyIconDelete],
["IconDeleteCircle", LazyIconDeleteCircle],
["IconDiscover", LazyIconDiscover],
["IconEmail", LazyIconEmail],
["IconEmpty", LazyIconEmpty],
["IconEnhance", LazyIconEnhance],
["IconEntrance", LazyIconEntrance],
["IconError", LazyIconError],
["IconFacebook", LazyIconFacebook],
["IconFavoriteCollect", LazyIconFavoriteCollect],
["IconFavorite", LazyIconFavorite],
["IconFire", LazyIconFire],
["IconMore", LazyIconMore],
["IconNameEditFinish", LazyIconNameEditFinish],
["IconNameEdit", LazyIconNameEdit],
["IconPic", LazyIconPic],
["IconProfile", LazyIconProfile],
["IconReddit", LazyIconReddit],
["IconReviewReject", LazyIconReviewReject],
["IconSearch", LazyIconSearch],
["IconShare", LazyIconShare],
["IconShread", LazyIconShread],
["IconTabRight", LazyIconTabRight],
["IconTrash", LazyIconTrash],
["IconTrends", LazyIconTrends],
["IconTwitter", LazyIconTwitter],
["IconTxtToImg", LazyIconTxtToImg],
["IconXxxx", LazyIconXxxx],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
